<template>
  <div id="app">
    <navigation></navigation>

    <div class="select-area warp">
      <div class="desc">
        <div>添加您需要的搜索比对的类型(支持PNG与JPG,最多100个文件同时上传)<span style="color:red">每幅作品20元</span></div>
        <div class="upload" style="text-algin:left">
          <el-upload
            name="multipartfiles"
            action="/api/file/upload"
            ref="upload"
            multiple 
            :file-list="fileList"
            accept=".png,.jpg" 
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-exceed="handleExceed" 
            :on-remove="handleRemove"
            :on-change="onChange"
            :on-success="onSuccess"
            :on-error="onError"
            :limit="100"
            :auto-upload="false">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
        <button @click="upload">上传原图片</button>
      </div>
    </div>

    <div class="list-area warp">
      <div style="padding:20px;">
        <div class="title"><div class="s"></div><div class="t">添加比对网址</div>
      </div>
          <!-- <div class="body1">
              <el-transfer
              style="width: 1000px"
              v-model="value" 
              :change="change(value)" 
              :button-texts="['撤销', '添加']"
              :titles="['添加比对网址', '已添加']"
              filterable
              :data="data">
            </el-transfer>
           </div> -->

           <div class="pt20" v-for="(item,key) in platformList" :key="key">
             <h3>{{item.title}}类
               &nbsp
               全选
               <input  type = "checkbox"  @change="typeAll(key,$event)" :name="'checkAll'+key" />
             </h3>
             <el-checkbox-group v-model="checkboxGroup1">
              <el-checkbox-button v-for="city in item.webs" @change="btnChange(key,$event)" :label="city.wid" :key="city.wid">{{city.title}}</el-checkbox-button>
            </el-checkbox-group>
           </div>

           <div class="clear_both"></div>
        <div style="border-bottom:1px solid #c8c8c8;height:38px;width:1160px;margin-top:20px">
          剩余监测次数：<span :style="user==null?'color:red':'color:green'">{{user==null?0:user.number}}</span>次/张
        </div>
        <div style="margin-top:20px">
          <el-input  v-model="reportTitle" placeholder="请输入本次报告名称" style="width:230px"/>
          <el-button type="primary" @click="createTask" style="margin-left:66%">创建监测比对任务</el-button>
        </div>
      </div>
      </div>
      <el-dialog
          :visible.sync="dialogVisible"
          width="16%"
          :close-on-press-escape="false"
          :close-on-click-modal="false"
          @opened="open"
          >
          <p style="color:green;mrgin-left:30px">微信扫码进行支付</p>
          <img  :src="wxPayUrl" v-if="wxPayUrl!=''" />
        </el-dialog>
    </div>
</template>
<script>
import Navigation from '@/components/area/Navigation.vue';
import {platformListApi,createTaskApi,userInfoApi,createOrderApi,orderCheckFApi ,uploadApi} from '@/service/allApi'
export default {
  data(){
    return {
      fileList:[],
      platformList:[],
      selectPlatList:[],
      selectTab : 0 ,
      reportTitle:"",
      user:null,
      dialogVisible:false,
      wxPayUrl:'',
      a:null,
      orderNo:'',
      data: null,
      value:[],
      wids:null,
      checkboxGroup1:[]
    }
  },
  created(){
    const user = JSON.parse( localStorage.getItem('user'))
   if(user.certification == 0 ){
     alert("请先进行实名认证")
     this.$router.push("/my?page=auth")
   }
    this.loadPlatformList();
  },
  mounted(){
   
  //  this.loadPlatformList()

     //获取登录信息
    this.userInfoApi();
    //获取监测路径
  },
  methods:{
   
    createTask(){
      // alert(this.checkboxGroup1)
      if(this.reportTitle == ""){
        this.$message.warning("请填写本次报告名称")
        return 
      }

      let pids = []
      let wids = this.checkboxGroup1
      for(let i = 0 ; i < this.fileList.length ; i ++){
        const file = this.fileList[i]
        if(file.pid > 0 ){
          pids.push(file.pid)
        }
      }
     
      if(pids.length == 0 ){
        this.$message.error("未上传照片")
        return 
      }
      if(wids.length == 0){
        this.$message.error("未选择监测平台")
        return 
      }

      if(this.user.number<this.fileList.length){
        var num = this.fileList.length - this.user.number
        this.$confirm('扣除你剩余的作品监测次数，还需要支付'+num +'副作品的费用', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.dialogVisible = true
        }).catch(() => {
             
        });
        return
      }else{
        var num = this.fileList.length;
        this.$confirm('将扣除你'+num+'次监测作品次数', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //this.dialogVisible = true
          this.addTsak(pids,wids)
        }).catch(() => {
             
        });
      }
    },

    addTsak(pids,wids){
      const strPids = pids.join(',')
      const strWids = wids.join(',')
      const options = {
        wids:strWids,
        pids:strPids,
        title:this.reportTitle
      }
      const that = this
      createTaskApi(options).then((res)=>{
        alert("创建监测比对任务")
        that.orderNo = ''
        that.$router.push("my?page=searching")
      }).catch((err)=>{

      })
    },

    open(){
      if(this.reportTitle == ""){
        this.$message.warning("请填写本次报告名称")
        return 
      }

      let pids = []
      let wids = this.checkboxGroup1
      for(let i = 0 ; i < this.fileList.length ; i ++){
        const file = this.fileList[i]
        if(file.pid > 0 ){
          pids.push(file.pid)
        }
      }
      
      if(pids.length == 0 ){
        this.$message.error("未上传照片")
        return 
      }
      if(wids.length == 0){
        this.$message.error("未选择监测平台")
        return 
      }

      if(this.orderNo!=''){
        that.wxPayUrl='/api/order/wechat_pay?orderNo='+that.orderNo+'&description='+1
        that.orderCheckF(pids,wids)
      }else{
        this.createOrder(pids,wids)
      }
    },

    // 创建订单
    async createOrder(pids,wids){
      var that =this
      var data = {
        price:(this.fileList.length-this.user.number)*0.1,
        pirs:pids.join(',')
      } 
      var res = await createOrderApi(data);
        if(res.data.code === 100){
            this.dialogVisible = true
            that.orderNo = res.data.data.orderNo
            that.wxPayUrl='/api/order/wechat_pay?orderNo='+that.orderNo+'&description='+1
            that.orderCheckF(pids,wids)
        }else{
            that.$router.push('/login')
        }
    },

    //微信监测支付情况
    async  orderCheckF(pids,wids){
        var that = this
        var data = {
                orderno:this.orderNo
            }
        that.a = setInterval(function () {
            that.payCheckF(pids,wids,data)
        }, 2000)
    },

    //同步监测支付信息
    async payCheckF(pids,wids,data){
      const res = await orderCheckFApi(data) 
      if(res.data!=undefined){
        if(res.data.code == 100){
            clearInterval(that.a)
            this.$message({
                message: '支付成功',
                type: 'success'
            });
            that.dialogVisible = false
            that.addTsak(pids,wids)
        }
      }
    },

    tabClick(tab, event){
      this.selectTab = tab.index
    },
    upload(){
      let length = this.fileList.length
      if(length == 0 ){
        this.$message.warning( '请选择需要上传的图片')
      }else{
        this.$refs.upload.submit();
     }
    },
    confirmSelect(){
      if(this.fileList.length == 0 ){
        this.$message({
          message:"请先选择需要上传的图片",
          type:"warning",
    
        });
        return
      }
      let allSuccess = true
      for(let i = 0 ; i < this.fileList.length ; i ++){
        const file = this.fileList[i]
        if(file.status != "success"){
          
          allSuccess = false
          break;
        }
      }
      if(!allSuccess){
        this.$message.warning('你选择的图片，部分未上传成功，请重试，或删除上传失败的图片')
        return
      }
      if(allSuccess){
        const curSelectPlat = this.platformList[this.selectTab]
        let exist = false
        for(let i = 0 ; i < this.selectPlatList.length ; i ++){
          const selectPlat = this.selectPlatList[i]
          if(selectPlat.cid == curSelectPlat.cid){
            exist = true
            break
          }
        }
        if(!exist){
          this.selectPlatList.push(curSelectPlat)
        }
      }
    },
    onChange(file,fileList){
      this.fileList = fileList
    },
    handleRemove(file,fileList){
      this.fileList = fileList
    },
    handleExceed(files,fileList){
      this.$message.warning('仅支持同时上传100个文件')
    },
    handlePictureCardPreview(file){
      console.log(file)
    },
     onSuccess(response,file,fileList){
      file.pid = -1
      file.status = "ready"

      if(response.code == 100){
       
        const pid = response.data.pid
        if(pid > 0 ){
           file.status = "success";
           file.pid = response.data.pid
        }
      }else if(response.code == -200){
        this.$message.warning('登录已超时，请重新登录')
      }else{
        this.$message.error('文件:' + file.name + "  上传失败") 
      }
    },
    onError(err,file,fileList){
      console.log(err)
      
    },
     userInfoApi(){
       userInfoApi().then((res2)=>{
          const code = res2.data.code
          if(code == 100){
            if(res2.data.data!=null){
              this.user = res2.data.data
              localStorage.setItem("user",JSON.stringify(res2.data.data))
            }else{
                localStorage.clear();
            }
          }
        })
    },

    async loadPlatformList(){
      const res = await platformListApi();
      if(res.data.code == 100){
        this.platformList = res.data.list
      }
    },
    //  generateData(){
    //   const data = [];
    //   var list = this.platformList
    //   for(let i=0;i<list.length;i++){
    //     for(let j =0;j<list[i].webs.length;j++){
    //       data.push({
    //           key: list[i].webs[j].wid,
    //           label: list[i].webs[j].title
    //       });
    //     }
    //   }
    //   this.data = data
    // },
    typeAll(key,event){
      var data =  this.platformList[key].webs
      event = event.target.checked;
      if(event){
        for(var i=0;i<data.length;i++){
          var a = false;
          for(var j=0;j<this.checkboxGroup1.length;j++){
            if(data[i].wid == this.checkboxGroup1[j]){
              a = true
            }
          }
          if(a){
              continue;
          }
          this.checkboxGroup1.push(data[i].wid)
        }
      }else{
        for(var i=0;i<data.length;i++){
          this.checkboxGroup1= this.removeVal(this.checkboxGroup1,data[i].wid)
        }
      }
      // console.log(this.checkboxGroup1)

    },
    removeVal(data,val){
        for(var i=0;i<data.length;i++){
          if(data[i]==val){
            data.splice(i,1);
          }
        }
        return data
    },
    btnChange(key,event){
        if(!event){
            document.getElementsByName("checkAll"+(key))[0].checked = false;
        }else{
          var  data = this.platformList[key].webs
          var num = 0;
          for(var i=0;i<data.length;i++){
              for(var j=0;j<this.checkboxGroup1.length;j++){
                if(this.checkboxGroup1[j] == data[i].wid){
                  num += 1;
                }
              }
          }
          if(num == data.length){
            document.getElementsByName("checkAll"+(key))[0].checked = true;
          }
        }
    }
  },

  components: {
    navigation: Navigation
  }
}
</script>
<style scoped src="../../static/css/Common.css"></style>
<style scoped src="../../static/css/Search.css"></style>


<style scoped>
.body1{
    border: green 1px solid;
    padding-left: 23%;
}
</style>


// WEBPACK FOOTER //
// src/components/Search.vue